import React from 'react';
import { createRoot } from 'react-dom/client';
import { RecoveryPointsBookingForm } from '../main-app/components/RecoveryPointsBookingForm';

document.addEventListener('DOMContentLoaded', () => {
  const resultContainer = document.querySelector('#react-points-booking-form-component');

  const root = createRoot(resultContainer);
  const point = resultContainer?.getAttribute('data-point');
  const startStep = resultContainer?.getAttribute('data-start-step') || 0;
  const centerData = resultContainer?.getAttribute('data-center');
  const paymentStatus = resultContainer?.getAttribute('data-payment-status');
  const initialPaymentData = resultContainer?.getAttribute('data-initial-payment-data');
  const parsedPaymentData = initialPaymentData ? JSON.parse(initialPaymentData) : null;

  root.render(
    <RecoveryPointsBookingForm
      point={point}
      startStep={+startStep}
      centerData={centerData}
      paymentStatus={paymentStatus}
      initialPaymentData={parsedPaymentData}
    />
  );
});
